import { Badge } from '@/components/ui/badge'
import { getChannelLabel } from '@/components/orders/orders-list-filter-options'

// Kênh bán của đơn (source_channel) dạng chip, cùng khuôn OrderStatusBadge:
// nền nhạt + chữ đậm cùng tông (tương phản AA↑), có bản dark. Online là đơn từ
// website nên tô đặc để nhân viên nhận ra ngay. Tông màu tránh trùng hẳn với chip
// trạng thái cùng hàng. Kênh lạ (source_channel là free-text) → trung tính.
export const CHANNEL_COLORS: Record<string, string> = {
    online: 'bg-fuchsia-700 text-white dark:bg-fuchsia-400 dark:text-fuchsia-950',
    zalo_mini_app: 'bg-blue-700 text-white dark:bg-blue-400 dark:text-blue-950',
    direct: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
    phone: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
    quick_order:
        'bg-lime-100 text-lime-800 dark:bg-lime-900/40 dark:text-lime-200',
    pos_delivery:
        'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200',
    agent: 'bg-pink-100 text-pink-800 dark:bg-pink-900/40 dark:text-pink-200',
    kiotviet:
        'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
    other: 'bg-stone-100 text-stone-700 dark:bg-stone-700/50 dark:text-stone-200',
}

const FALLBACK_COLOR =
    'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-200'

/** Nhãn kênh: KiotViet viết như ô lọc kênh; còn lại theo getChannelLabel. */
export function channelBadgeLabel(channel: string): string {
    return channel === 'kiotviet' ? 'KiotViet' : getChannelLabel(channel)
}

export function OrderChannelBadge({
    channel,
}: {
    channel: string | null | undefined
}) {
    // Không có kênh thì không vẽ viên pill rỗng (cùng khuôn OrderStatusBadge).
    if (!channel?.trim()) return null
    return (
        <Badge className={CHANNEL_COLORS[channel] ?? FALLBACK_COLOR}>
            {channelBadgeLabel(channel)}
        </Badge>
    )
}
